<div #header mat-dialog-title>
  How To Check In/ Check Out
</div>

<mat-dialog-content style="padding-top: 10px !important;">
  <div>
    Selecting the Check In or Check Out buttons will start a wizard style process with the following steps: <br><br>

      <span style="padding-left: 20px;">Select the students checking in or out.</span>  <br><br>

      <span style="padding-left: 20px;">Enter the check in or check out time for the students and override the missed periods attendance code.</span><br><br>

      <span style="padding-left: 20px;">Review, and override if needed, each selected student’s Check In/Check out information and the effect on their attendance.</span> <br><br>

      <span style="padding-left: 20px;">To avoid making changes for a student that was originally selected the user can use the Clear Changes button and navigate to the next student.</span><br><br>

    NOTE:  No changes will be saved until all students have been reviewed.
  </div>
</mat-dialog-content>

<mat-dialog-actions #footer>
  <div class='flex-footer-right'>
    <tyl-button image="Cancel.png" label="Close" (click)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>